import React, { useState } from 'react';
import UsersList from 'app/scripts/components/common/users';
import { useSelector } from 'react-redux';
import { State } from 'state';
import User from 'app/scripts/models/user';
import AssignReporter from '../../../../../../components/common/inputs/user-assignment';
import { getLiveBlogTeam } from '../../../state/reducer';
import AddReporterControls from './UserControls/AddReporter';
import RemoveReporterControls from './UserControls/RemoveReporter';

interface Props {
  eventId: string;
  reporterIds: string[];
  error: boolean;
  addReporter: (user: User) => void;
  removeReporter: (user: User) => void;
}

type UserSearchType = 'username' | 'email';

const Reporters: React.FC<Props> = ({
  eventId,
  reporterIds = [],
  addReporter,
  removeReporter,
  error
}) => {
  const { suggestions = [], reporters = [] } = useSelector((state: State) =>
    getLiveBlogTeam(state, reporterIds)
  );
  const [userSearchType, setUserSearchType] = useState<UserSearchType>('username');

  const searchPlaceholder =
    userSearchType === 'username' ? 'Type username...' : 'Enter user email (exact match)';

  return (
    <div className={'reporters-container'}>
      <AssignReporter
        title={'Assign Reporters'}
        description={
          'Select reporters from this list. Assigned reporters will be able to manage the event and post updates.'
        }
        type={'reporters'}
        eventId={eventId}
        onSearchTypeChange={setUserSearchType}
        searchUserBy={userSearchType}
        placeholder={searchPlaceholder}
        userControls={({ user, onItemSelected }) => {
          const updatedIds = reporters.map(r => r.get('id'));
          return (
            <AddReporterControls
              user={user}
              onItemSelected={onItemSelected}
              addReporter={addReporter}
              alreadyAssigned={updatedIds.includes(user.id)}
            />
          );
        }}
      />

      {reporters.length > 0 && (
        <UsersList
          eventId={eventId}
          users={reporters}
          type="reporters"
          userControls={({ user, onItemSelected }) => (
            <RemoveReporterControls
              user={user}
              onItemSelected={onItemSelected}
              removeReporter={removeReporter}
            />
          )}
        />
      )}

      {suggestions.length > 0 && (
        <div className={'reporters-suggestions'}>
          <h6>Suggestions from your team: </h6>
          <UsersList
            users={suggestions}
            userControls={({ user, onItemSelected }) => (
              <AddReporterControls
                user={user}
                onItemSelected={onItemSelected}
                addReporter={addReporter}
              />
            )}
          />
        </div>
      )}
      {error && (
        <span className={'live-blog-error-message'}>You must assign at least one reporter.</span>
      )}
    </div>
  );
};

export default Reporters;
